import { base64ArrayBuffer } from '../../../utils/imgUtil'

export const LOG_OUT = 'LOG_OUT'
export const SEND_LOG_IN_REQUEST = 'SEND_LOG_IN_REQUEST'
export const RECEIVE_LOG_IN_RESPONSE = 'RECEIVE_LOG_IN_RESPONSE'
export const CHECK_LOCAL_STORAGE_LOGIN = 'CHECK_LOCAL_STORAGE_LOGIN'
export const CHANGE_NAME = 'CHANGE_NAME'
export const CHANGE_AVATAR = 'CHANGE_AVATAR'

export const logOut = () => ({
  type: LOG_OUT
})

const sendLogInRequest = () => ({
  type: SEND_LOG_IN_REQUEST
})

const receiveLogInResponse = (personId, userId, email, name, avatar) => ({
  type: RECEIVE_LOG_IN_RESPONSE,
  personId,
  userId,
  email,
  name,
  avatar: `data:image/jpeg;base64,${avatar}`
})

export const fetchLogIn = (email, password, keepLoggedIn) => (dispatch) => {
  dispatch(sendLogInRequest())

  return fetch(
    process.env.REACT_APP_BASE_URL + '/account/login',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({
        email,
        password,
        keepLoggedIn
      })
    })
    .then(
      response => response.json(),
      error => console.error(error)
    ).then(
      response =>
        response
          ? dispatch(receiveLogInResponse(
            response.personId,
            response.userId,
            response.email,
            response.name,
            response.avatar
          ))
          : dispatch(receiveLogInResponse())
    )
}

export const fetchChangeName = (newName, personId) => (dispatch) => {
  return fetch(
    process.env.REACT_APP_BASE_URL + '/personalroom/update_name',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({
        personId,
        newName
      })
    })
    .then(
      response => dispatch(changeName(newName))
    )
}

export const fetchChangeAvatar = (newAvatar, personId) => (dispatch) => {
  return fetch(
    process.env.REACT_APP_BASE_URL + '/personalroom/update_avatar',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({
        personId,
        newAvatar: newAvatar.blob
      })
    })
    .then(
      response => dispatch(changeAvatar(newAvatar.base64))
    )
}

export const checkLocalStorageLogin = () => ({
  type: CHECK_LOCAL_STORAGE_LOGIN,
  personId: localStorage.getItem('personId'),
  userId: localStorage.getItem('userId'),
  email: localStorage.getItem('email'),
  name: localStorage.getItem('name'),
  avatar: localStorage.getItem('avatar')
})

export const changeName = (name) => {
  return ({
    type: CHANGE_NAME,
    payload: {
      name
    }
  })
}

export const changeAvatar = (avatar) => {
  return ({
    type: CHANGE_AVATAR,
    payload: {
      avatar
    }
  })
}
